import { Component, Input, OnInit } from '@angular/core';
import {MemberFeeFullPrice} from '../../../models/member/member-fee/member-fee-full-price';

@Component({
    selector: 'app-member-fee-card',
    templateUrl: './member-fee-card.component.html',
    styleUrls: ['./member-fee-card.component.scss']
})
export class MemberFeeCardComponent implements OnInit {
    @Input() memberFee!: MemberFeeFullPrice;
    @Input() selected = false;

    memberFeeName = '';

    ngOnInit(): void {
        this.memberFeeName = `${this.memberFee.title}`;
    }
}

